import { render, staticRenderFns } from "./productSelector.vue?vue&type=template&id=18232371"
import script from "./productSelector.vue?vue&type=script&lang=js"
export * from "./productSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports